import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { EM_DASH } from 'libs.constants';
import { useLocalizeMessage } from 'libs.nucleus';
export const usePIOversightDetailsTableColumns = () => {
    const translate = useLocalizeMessage();
    const dcrItemsTableColumns = useMemo(() => {
        return [
            {
                header: translate('label.pi_oversight.review.activity'),
                accessorKey: 'activity',
                cell: (context) => {
                    const value = context.row.original.activity;
                    return _jsx("span", { className: 'text-text-secondary', children: value });
                },
            },
            {
                header: translate('label.pi_oversight.review.question'),
                accessorKey: 'question',
                cell: (context) => {
                    const value = context.row.original.question;
                    return _jsx("span", { className: 'text-text-secondary', children: value });
                },
            },
            {
                header: translate('label.pi_oversight.review.old_response'),
                accessorKey: 'oldResponse',
                cell: (context) => {
                    const value = String(context.row.original.oldValue);
                    return _jsx("span", { className: 'font-semibold', children: value ?? EM_DASH });
                },
            },
            {
                header: translate('label.pi_oversight.review.new_response'),
                accessorKey: 'newResponse',
                cell: (context) => {
                    const value = String(context.row.original.newValue);
                    return _jsx("span", { className: 'font-semibold', children: value ?? EM_DASH });
                },
            },
            {
                header: translate('label.pi_oversight.review.reason_for_change'),
                accessorKey: 'reasonForChange',
                cell: (context) => {
                    const value = context.row.original.reason;
                    return _jsx("span", { className: 'text-text-secondary', children: value ?? EM_DASH });
                },
            },
        ];
    }, []);
    const taskResponsesTableColumns = useMemo(() => {
        return [
            {
                header: translate('generic.question'),
                accessorKey: 'question',
                cell: (context) => {
                    const { question_text, name: screenName } = context.row.original;
                    // see listParticipantResponses in axon/org for more details
                    const questionText = question_text || screenName;
                    return _jsx("div", { className: 'text-sm text-text-secondary', children: questionText });
                },
            },
            {
                header: translate('generic.responses', { count: 1 }),
                accessorKey: 'response',
                cell: (context) => {
                    const value = String(context.row.original.value ?? EM_DASH);
                    return _jsx("span", { className: 'text-sm text-text-secondary', children: value });
                },
            },
        ];
    }, []);
    return {
        dcrItemsTableColumns,
        taskResponsesTableColumns,
    };
};
